export default __webpack_public_path__ + "static/media/download.117169b7.jpg";